import { render, staticRenderFns } from "./payment-gateway-sycurio.vue?vue&type=template&id=617126ad&scoped=true"
import script from "./payment-gateway-sycurio.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-gateway-sycurio.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617126ad",
  null
  
)

export default component.exports